import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { modifyNineBoxSettingsAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const { data, handleClose } = props;
  const dispatch = useDispatch();

  const modify = (validatedData) => {
    const dataToSend = { ...data, ...validatedData };
    dispatch(modifyNineBoxSettingsAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, modify, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* codigo */}
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("quadrantPositionYX")}
            value={data.code}
            inputProps={{ maxLength: 3 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* cuadrante */}
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("publicationNumber")}
            value={data.quadrant}
            inputProps={{ maxLength: 1 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* nombre */}
          <TextField
            fullWidth
            required
            margin={"none"}
            label={getLocalizedString("quadrantName")}
            value={formData.name}
            onChange={(e) => setFormValue(e.target.value, "name")}
            inputProps={{ maxLength: 40 }}
          />
        </Grid>  <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* recomendación */}
          <TextField
            fullWidth
            margin={"none"}
            label={getLocalizedString("recommendation")}
            value={formData.recommendation}
            onChange={(e) => setFormValue(e.target.value, "recommendation")}
            inputProps={{ maxLength: 40 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}> {/* descripcion */}
          <TextFieldMultiline
            required
            fullWidth
            label={getLocalizedString("quadrantDescription")}
            rows={5}
            margin={"none"}
            value={formData.description}
            onChange={(e) => setFormValue(e.target.value, "description")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}> {/* descripcion */}
          <TextFieldMultiline
            fullWidth
            label={getLocalizedString("quadrantFeatures")}
            rows={5}
            margin={"none"}
            value={formData.quadrantCharacteristics}
            onChange={(e) => setFormValue(e.target.value, "quadrantCharacteristics")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>
    </Grid>
  );
}

export default Form;
